/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

// slices of states
import accountData from 'state/reducers/accountState/account_data';
import authStatus from 'state/reducers/auth_status';
import detailViewStatus from 'state/reducers/detailViewState/detailView_status';
import overlayStatus from 'state/reducers/overlay_status';
import profileStatus from 'state/reducers/profile_status';
import sessionStatus from 'state/reducers/session_status';
import userStatus from 'state/reducers/user_status';

// combined slices of state
import embedsStateRootReducer from 'state/reducers/embedsState/root';
import homeRootReducer from 'state/reducers/homeState/root';
import reportsStateRootReducer from 'state/reducers/reportsState/root';
import emailCollectionState from 'state/reducers/emailCollectionState/root';
import commentingState from 'state/reducers/commentingState/root';
import ratingsState from 'state/reducers/ratingsState/root';


// insticator-ui state
import { appStatus, messageStatus, modalStatus, history } from '@insticator/insticator-ui'; // iui-material


/* ========== ~~~~~~~~~~ ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const rootReducer = combineReducers({
    embedsState: embedsStateRootReducer,
    homeState: homeRootReducer,
    reportsState: reportsStateRootReducer,
    router: connectRouter(history),
    appStatus,
    messageStatus,
    modalStatus,
    accountData,
    authStatus,
    commentingState,
    ratingsState,
    emailCollectionState,
    detailViewStatus,
    overlayStatus,
    profileStatus,
    sessionStatus,
    userStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default rootReducer;
